module.exports = __webpack_public_path__ + "assets/img/right-title-open-b04cff18.png";